<div class="container-fluid">
  <app-header titleText="Lost Quote Analysis Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
    <div class="row header-text">

      <div class="col-md-4">
        <app-dealer-logo></app-dealer-logo>
      </div>
      <div class="col-md-6 filter-zone">
        <p>
          <span i18n>REPORT DEFINED:</span><br />
          <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
          <ng-template [ngIf]="salesperson"><span i18n>Salesperson:</span> {{salesperson.firstName}} {{salesperson.lastName}}<br /></ng-template>
          <ng-template [ngIf]="quoteStatus"><span i18n>Quote Status:</span> {{quoteStatus}}<br /></ng-template>
          <ng-template [ngIf]="jobType"><span i18n>Job Type:</span> {{jobType.jobType_Desc}}<br /></ng-template>
          <ng-template [ngIf]="customerType"><span i18n>Customer Type:</span> {{customerType.customerType_Desc}}<br /></ng-template>
          <ng-template [ngIf]="customer"><span i18n>Customer:</span> {{customer.customer_BusinessName}}<br /></ng-template>
        </p>
      </div>

    </div>

    <div class="content">
      <div class="quote-annual-summary">
        <h2 i18n>Quotes</h2>
        <div>
          <table class="table table-bidit">
            <thead>
              <tr>
                <th i18n>Competitor</th>
                <th i18n>Created</th>
                <th i18n>Salesperson</th>
                <th i18n>Customer</th>
                <th i18n>Project Name</th>
                <th i18n>Job Type</th>
                <th i18n>Status</th>
                <th i18n>Job $</th>
                <th *ngIf="showMargins" i18n>Margin $</th>
                <th *ngIf="showMargins" i18n>Margin %</th>
                <th i18n>View</th>
              </tr>
            </thead>
            <tbody>
              <ng-template ngFor let-groupData [ngForOf]="report.groupData">
                <tr>
                  <td colspan="11">
                    <span i18n>Lost Reason:</span> {{groupData.lostReason}}
                  </td>
                </tr>
                <tr *ngFor="let quote of groupData.quoteDetails">
                  <td>
                    <ng-template [ngIf]="quote.competitor">
                      {{quote.competitor.competitor_Desc}}
                    </ng-template>
                  </td>
                  <td>{{quote.quote_Created | date: 'M/d/yyyy'}}</td>
                  <td>
                    {{quote.salesperson}}
                  </td>
                  <td>
                    <ng-template [ngIf]="quote.customer">
                      {{quote.customer.customer_BusinessName}}
                    </ng-template>
                  </td>
                  <td>{{quote.quote_Name}}</td>
                  <td>
                    <ng-template [ngIf]="quote.jobType">{{quote.jobType.jobType_Desc}}</ng-template>
                  </td>
                  <td>{{quote.quoteStatus}}</td>
                  <td>
                    <ng-template [ngIf]="quote.quote_BidAmount">
                      ${{quote.quote_BidAmount | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td *ngIf="showMargins">
                    <ng-template [ngIf]="quote.quote_BidAmount">
                      ${{quote.quote_BidAmount - quote.totalCost | number: '1.2-2'}}
                    </ng-template>
                  </td>
                  <td *ngIf="showMargins">
                    <ng-template [ngIf]="quote.quoteMargin">
                      {{quote.quote_GrossMargin | number: '1.2-4' }} %
                    </ng-template>
                  </td>
                  <td>
                    <a routerLink="/quote/{{quote.quote_ID}}" class="btn btn-bidit-submit" i18n>View</a>
                  </td>
                </tr>
                <tr class="lost-reason-summary-row">
                  <td colspan="2">
                    {{groupData.lostReason}} <span i18n>Totals</span>
                  </td>
                  <td></td>
                  <td>
                  </td>
                  <td></td>
                  <td>
                  </td>
                  <td></td>
                  <td>
                    ${{groupData.totalBidAmount | number: '1.2-2'}}
                  </td>
                  <td *ngIf="showMargins">
                      ${{groupData.bidAmount - groupData.totalCost | number: '1.2-2'}}
                  </td>
                  <td *ngIf="showMargins">
                    {{groupData.quoteMargin * 100 | number: '1.2-2' }} %
                  </td>
                  <td>
                  </td>
                </tr>
              </ng-template>
              
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
